<template>
  <div class="flex flex-wrap" v-if="user && !user.isAdmin">
    <div class="w-full md:w-3/4 md:pr-20">
      <div class="border-b border-gray-hr">
        <h1 class="mb-5 text-n-gray-dark">Your Upcoming Events</h1>
        <router-link class="button mb-12" to="/events/create">
          Create New Event
        </router-link>

        <div class="mb-8">
          <p class="mb-5">
            Your event dashboard is where you’ll see the event(s) you’re working on and the status (draft, in review, published, etc.) You can select the saved event to make edits. If you ever lose your way in the portal, click the “My Events” tab in the top navigation. You can begin adding an event by clicking "Create New Event.” Once submitted, Reimagine will review your event to ensure it's aligned with our mission and values prior to publishing. Reimagine reserves the right to not publish an event.
          </p>
        </div>
      </div>

      <div class="flex flex-wrap -mx-6 pt-12">
        <dashboard-event-item
          :event="event"
          v-for="event in events"
          :key="event.id"
        />
      </div>

      <hr>

      <router-link class="button button__medium mb-10" to="/past-events">
        View Past Events
      </router-link>
    </div>

    <div class="w-full md:w-1/4 md:pt-40">
      <div class="sidebar-block border-t-5 border-black pt-3">
        <public-profile-link></public-profile-link>

        <h2 class="text-lg mb-5 font-sans text-n-gray-dark">Help with My Events</h2>
        <ul class="list-reset mb-10 text-base">
          <li class="mb-2"><a target="_blank" href="https://help.letsreimagine.org/hc/en-us/sections/360008557151-Creating-submitting-your-events">Creating &amp; Submitting Events</a></li>
        </ul>

        <support></support>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DashboardEventItem from "./DashboardEventItem.vue";
import moment from "moment";
import Support from "../global/Support.vue";
import PublicProfileLink from "../global/PublicProfileLink.vue";
import NewTabA11y from "../global/a11y/NewTabA11y.vue";

export default {
  name: "Dashboard",
  title: "Dashboard",
  components: {
    NewTabA11y,
    "dashboard-event-item": DashboardEventItem,
    Support,
    PublicProfileLink
  },
  computed: {
    ...mapGetters({
      user: "user",
      events: "events",
      festivals: "festivals"
    }),
    currentFestivals() {
      const now = moment();

      return _.filter(this.festivals, function(festival) {
        let gaEndDay = moment(festival.gaEndDay);
        return gaEndDay > now;
      });
    }
  },
  watch: {
    // call again the method if the route changes
    $route: "getEvents"
  },
  methods: {
    getEvents() {
      this.$store.dispatch("getMyEvents");
    }
  },
  mounted() {
    this.getEvents();
    this.$store.dispatch("getFestivals");
  }
};
</script>
